import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'PhoneNumbersPage.title',
    defaultMessage: 'Phone Numbers',
  },
  countries: {
    id: 'PhoneNumbersPage.countries',
    defaultMessage: 'Countries',
  },
  numbers: {
    id: 'PhoneNumbersPage.numbers',
    defaultMessage: 'Phone Numbers',
  },
  tollFree: {
    id: 'PhoneNumbersPage.tollFree',
    defaultMessage: 'Toll Free',
  },
});



// WEBPACK FOOTER //
// ./components/pages/PhoneNumbersPage/messages.js